// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"NewThankYouPage_mainWrapper__7v8Wl","thankyouWrapper":"NewThankYouPage_thankyouWrapper__19X8X","btnDone":"NewThankYouPage_btnDone__2Aa5r"};